import { useMedia } from 'react-use'

export const useMediaQuery = () => {
  const isDesktop = useMedia('(min-width: 1024px)', true)
  return {
    isDesktop,
  }
}
